import { getMasterData } from 'src/api/masterData';
import { INITIALIZE_COMPLETE, SET_MASTER_DATA } from './constants';
import { message } from 'antd';
import { notificationInitialisation } from 'src/components/pages/Notifications/notification.action';

export const loadInitialData = () => async (dispatch, getState) => {
  let masterData: any = null;
  const masterDataResponse = await getMasterData();
  if (masterDataResponse.isSuccess) {
    masterData = masterDataResponse.data;
  } else {
    message.error(masterDataResponse.errorMessage);
  }
  if (masterData) {
    dispatch({
      type: SET_MASTER_DATA,
      data: masterData,
    });

    notificationInitialisation(dispatch);

    // initialization complete
    dispatch({
      type: INITIALIZE_COMPLETE,
    });
  }
};
